import { batchStateUpdates } from '@exodus/headless-react';
import React, { useCallback, useMemo } from 'react';
import useFromAmount from '../../hooks/use-from-amount.js';
import useFromAsset from '../../hooks/use-from-asset.js';
import useFromWalletAccount from '../../hooks/use-from-wallet-account.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
import useToAmount from '../../hooks/use-to-amount.js';
import useToAsset from '../../hooks/use-to-asset.js';
import useToWalletAccount from '../../hooks/use-to-wallet-account.js';
import { useFromAssets } from '../../context/assets.js';
import useToSideLoading from '../../hooks/use-to-side-loading.js';
import useTrackAssetConfigureEvent from '../../hooks/analytics/use-track-configure-asset.js';
import { useLimitsContext } from '../../context/limits.js';
const FlipButton = ({ Component, className, style, onPress }) => {
    const [fromAsset, setFromAsset] = useFromAsset();
    const [toAsset, setToAsset] = useToAsset();
    const [, setFromAmount] = useFromAmount();
    const [, setToAmount] = useToAmount();
    const [fromWalletAccount, setFromWalletAccount] = useFromWalletAccount();
    const [toWalletAccount, setToWalletAccount] = useToWalletAccount();
    const [, setPrefilledAmountId] = usePrefilledAmountId();
    const fromAssets = useFromAssets();
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const toSideLoading = useToSideLoading();
    const limits = useLimitsContext();
    const loading = toSideLoading || limits.loading;
    const isFlippable = useMemo(() => fromAssets.value?.some(({ name }) => toAsset.name === name), [fromAssets.value, toAsset.name]);
    const handlePress = useCallback(async () => {
        void trackAssetConfigureSwap();
        if (onPress)
            await onPress();
        batchStateUpdates(() => {
            setFromAsset(toAsset.name);
            setToAsset(fromAsset.name);
            setFromAmount(fromAsset.currency.ZERO);
            setToAmount(toAsset.currency.ZERO);
            setFromWalletAccount(toWalletAccount);
            setToWalletAccount(fromWalletAccount);
            setPrefilledAmountId(null);
        });
    }, [
        fromAsset,
        fromWalletAccount,
        setFromAmount,
        setFromAsset,
        setFromWalletAccount,
        setPrefilledAmountId,
        setToAmount,
        setToAsset,
        setToWalletAccount,
        toAsset,
        toWalletAccount,
        onPress,
        trackAssetConfigureSwap,
    ]);
    if (Component) {
        return (React.createElement(Component, { className: className, disabled: !isFlippable || loading, style: style, onPress: handlePress }));
    }
    return null;
};
export default FlipButton;
